import React from 'react';
import DentalUsageBlock from './DentalUsageBlock.js';
import ParamedicalsUsageBlock from './ParamedicalsUsageBlock.js';
import DrugsUsageBlock from './DrugsUsageBlock.js';
import VisionUsageBlock from './VisionUsageBlock.js';
import HealthUsageBlock from './HealthUsageBlock.js';
import { colors } from '../../theme/index.js';

/**
 *
 * @param {*} param0
 */
const UsageTab = ({ usage, coverage, waivedEHC, waivedDental, fillColor = 'skyBlue' }) => (
    <div style={{ 
        backgroundColor: colors.surface,
        boxShadow: '0 1px 2px rgba(0, 0, 0, .15)',
        display: 'block',
        margin: 'auto auto 30px auto',
        padding: '30px',
        position: 'relative',
        zIndex: 3 
    }}
    >
        {
            (coverage.dental.benefitActive === 1 || usage.dental.used.length > 0) &&
                <DentalUsageBlock
                    usage={ usage.dental }
                    coverage={ coverage.dental }
                    fillColor={ fillColor }
                    waivedDental={ waivedDental }
                />
        }

        {
            (coverage.paramedicals.benefitActive === 1 || usage.paramedicals.used.length > 0) &&
                <ParamedicalsUsageBlock
                    usage={ usage.paramedicals }
                    coverage={ coverage.paramedicals }
                    fillColor={ fillColor }
                    waivedEHC={ waivedEHC }
                />
        }

        {
            (coverage.drugs.benefitActive === 1 || usage.drugs.used.length > 0) &&
                <DrugsUsageBlock
                    usage={ usage.drugs }
                    coverage={ coverage.drugs }
                    fillColor={ fillColor }
                    waivedEHC={ waivedEHC }
                />
        }
        {   
            (coverage.vision.benefitActive === 1 || usage.vision.used.length > 0) &&
                <VisionUsageBlock
                    usage={ usage.vision }
                    coverage={ coverage.vision }
                    fillColor={ fillColor }
                    waivedEHC={ waivedEHC }
                />
        }

        {
            (coverage.majorMedical.benefitActive === 1 || usage.majorMedical.used.length > 0) &&
                <HealthUsageBlock
                    usage={ usage.majorMedical }
                    coverage={ coverage.majorMedical }
                    fillColor={ fillColor }
                    waivedEHC={ waivedEHC }
                />
        }
    </div>
);

export default UsageTab;